/**
 * Thin, informational strip noting that Lizrd is in private beta. Shown app-wide
 * while the build-time flag VITE_BETA_MODE is on (staging today; prod at a beta
 * launch). Purely a notice — no CTA (unlike the marketing site's banner, which
 * links to the waitlist). Renders nothing when the flag is off.
 */
import { BETA_MODE } from '../lib/beta';
import { Mark } from './brand/Logo';

export function BetaBanner() {
  if (!BETA_MODE) return null;

  return (
    <div
      className="flex items-center justify-center gap-2 border-b border-iris/40 px-4 py-1.5 text-center text-xs"
      style={{ backgroundColor: 'color-mix(in srgb, var(--iris) 14%, var(--obsidian))' }}
      role="status"
    >
      <Mark size={14} />

      <span className="font-medium text-bone">
        Lizrd is in <strong className="text-iris">private beta</strong>.
      </span>
    </div>
  );
}
